var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarWithArrows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3707_52030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25977 15C5.25977 20.3707 9.62915 24.7402 14.9998 24.7402C20.3705 24.7402 24.7399 20.3707 24.7399 15C24.7399 9.62936 20.3705 5.25989 14.9998 5.25989C9.62915 5.25989 5.25977 9.62936 5.25977 15ZM23.3546 15C23.3546 19.6069 19.6066 23.3549 14.9998 23.3549C10.393 23.3549 6.64505 19.6069 6.64505 15C6.64505 10.3931 10.393 6.64518 14.9998 6.64518C19.6066 6.64518 23.3546 10.3931 23.3546 15Z",
    fill: "#200E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3767 9.54245V10.6274C13.9869 10.7175 13.619 10.8867 13.2805 11.1367C12.3541 11.8204 11.9377 12.7679 12.1667 13.6712C12.3869 14.5398 13.1772 15.1712 14.2292 15.3186C16.6144 15.6529 17.0026 16.0091 16.9005 16.8445C16.8461 17.2896 16.5903 17.6083 16.1401 17.7913C15.379 18.1009 14.0595 17.9695 12.8267 16.9789L11.959 18.0587C12.7044 18.6577 13.5465 19.0543 14.3765 19.2273V20.4574H15.7618V19.3001C16.0761 19.2637 16.3786 19.1896 16.6618 19.0744C17.5726 18.7042 18.1607 17.9526 18.2756 17.0123C18.406 15.9451 17.9874 15.1193 17.0651 14.6242C16.3503 14.2404 15.4067 14.0846 14.4215 13.9466C13.9307 13.8779 13.5898 13.6475 13.5095 13.3306C13.4237 12.9923 13.6456 12.5888 14.103 12.2512C14.5874 11.8937 15.1583 11.8411 15.8481 12.0901C16.4335 12.3015 16.8648 12.6552 16.869 12.6587L17.3126 12.1268L17.7581 11.5964C17.6984 11.5462 17.152 11.0979 16.3642 10.8039C16.1607 10.7279 15.9598 10.6699 15.7619 10.6281V9.54236L14.3767 9.54245Z",
    fill: "#200E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1.38529C17.9793 1.38529 20.8133 2.33717 23.1547 4.09556H21.3332V5.48085H25.7906V1.02345H24.4053V3.3137C21.7479 1.16715 18.4629 0 15 0C6.72899 0 0 6.72899 0 15H1.38529C1.38529 7.49284 7.49284 1.38529 15 1.38529Z",
    fill: "#200E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6153 15C28.6153 22.5072 22.5077 28.6147 15.0006 28.6147C12.1058 28.6147 9.34018 27.7127 7.0346 26.0436H8.84314V24.6583H4.38574V29.1157H5.77103V26.8251C8.39809 28.8821 11.6192 30 15.0006 30C23.2717 30 30.0006 23.2711 30.0006 15H28.6153Z",
    fill: "#200E32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3707_52030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarWithArrows);
export default __webpack_public_path__ + "static/media/dollar_with_arrows.261d6ed3a7fa77d45d0cd61ab815c85c.svg";
export { ForwardRef as ReactComponent };